import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';

@Component({
  selector: 'dashlayout-header-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  menuDropdown:boolean = false;
  constructor(public globalHelper:GlobalHelper) { }

  ngOnInit(): void {
  }

  toggleMenu(){
    this.menuDropdown = !this.menuDropdown;
  }

}
